<div class="card" style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body">
                <h2 style="color: #ff5a00 ;">Articles</h2>
                <div class="" style="margin: auto;"><img style="width: 100%;    border-radius: 10%;"
                                src="assets/img/orientation.jpg"></div>
                <p style="font-size: 18px;">Orientation des jeunes bacheliers et insertion
                        professionnelle <a style="color: #ff5a00; font-size: 16px;" target="_blank"
                                href="assets/docs/Orientation_professionnelle_JB.pdf" class="stretched-link">Télécharger
                                l'article</a></p>
                <hr>
                <div class="" style="margin: auto;"><img style="width: 100%;    border-radius: 10%;"
                                src="assets/img/articles.jpg">
                </div>
                <p style="font-size: 18px;">Préparer son insertion professionnelle pendant ses études
                        supérieures <a style="color: #ff5a00; font-size: 16px;" target="_blank" href="v"
                                class="stretched-link">Télécharger
                                l'article</a></p>
                <hr>
                <div class="" style="margin: auto;"><img style="width: 100%;    border-radius: 10%;"
                                src="assets/img/writting.jpg   ">
                </div>
                <p style="font-size: 18px;">Les techniques de rédaction d’un CV professionnel <a
                                style="color: #ff5a00; font-size: 16px;" target="_blank"
                                href="assets/docs/redaction_cv.pdf" class="stretched-link">Télécharger
                                l'article</a></p>
                <hr>
        </div>
</div>